import useTranslation from 'next-translate/useTranslation';

import { Translate } from '@core/constant';
import { EActionAttribute, EColor, ESize } from '@core/type';

import { ButtonIcon } from '../button';
import { LinkTranslatedStyledAsLink } from '../link-translated';
import { TooltipSmallDescription } from '../tooltip';
import { SocialLinkProps } from './interface-socialLink';

export const LinkSocial = ({ type, href, height, width, content }: SocialLinkProps) => {
  const { t } = useTranslation(Translate.common.ARIA);

  return (
    <LinkTranslatedStyledAsLink href={href} target={'_blank'}>
      <TooltipSmallDescription borderRadius={'50%'} content={content} top={'4px !important'}>
        <ButtonIcon
          iconProps={{
            type,
            size: ESize.XL,
            height,
            width,
          }}
          hoverFill={{ commonType: EColor.WHITE, intensity: EColor.R700 }}
          backgroundColor={EColor.SECONDARY}
          hoverStyles={{ backgroundColor: EColor.PRIMARY }}
          as={EActionAttribute.SPAN}
          display={'flex'}
          alignItems={'center'}
          justifyContent={'center'}
          height={'40px'}
          width={'40px'}
          borderRadius={'50%'}
          aria-label={t('weOnSocialMedia')}
        />
      </TooltipSmallDescription>
    </LinkTranslatedStyledAsLink>
  );
};
